var mzg;
if (!mzg) {
    mzg = {};
}

$.extend(mzg,
    /**
     * @lends mzg
     */
    {
        /**
         * @namespace
         * @description table
         */
        table: {
            _obj: null,
            _selector: '',
            _config: {
            },
            /**
             * @type {function}
             * @description initialize tablesorter
             */
            init: function () {
                if($('.table--sortable').length){
                    $('.table--sortable').tablesorter({
                        theme : "bootstrap"
                    });
                }
            }
        }
    }
);

$(mzg.table.init);
